<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between">
            <div class="page-title line-height">组织服务</div>
            <div class="flex align-center">
                <router-link v-if="user.isBranch" class="page-operate yellow" to="/branch/organ/serverEdit/0">添加项目
                </router-link>
                <div v-if="user.isBranch" class="page-back margin-left-sm" @click="sortList">
                    {{ isSort ? '保存' : '排序' }}
                </div>
            </div>
        </div>
        <div class="classifys flex align-center">
            <router-link class="classify " to="/branch/service/list">我接收的</router-link>
            <router-link class="classify active" to="/branch/organ/server">我的发布</router-link>
        </div>
        <empty v-if="noData" :type="5"/>
        <div class="flex flex-direction">
            <vuedraggable v-model="lists"
                          :move="onMove"
                          class="swrapper"
                          v-bind="dragOptions"
                          @end="isDragging=false"
                          @start="isDragging=true"
                          @update="draggableEnd">
                <transition-group>
                    <div v-for="(item) in lists" :key="item.id"
                         :class="{sort:!isSort}" class="item flex flex-direction justify-center">
                        <div class="title ovHide">{{ item.title }}</div>
                        <div class="content ovHide2">
                            {{ item.desc }}
                        </div>
                        <div class="line"></div>
                        <div class="flex align-center justify-between">
                            <div class="flex flex-wrap align-center">
                                <div class="count"><span>{{ item.serverCount }}</span>项服务</div>
                                <div v-for="(tag,position) in item.label" :key="position" class="tag">{{ tag }}</div>
                            </div>
                            <router-link :to="'/branch/organ/serverDetail/'+item.id" class="look">
                                <span>{{ item.newServerMsg }}</span>新申请
                            </router-link>
                        </div>
                        <div v-if="user.isBranch" class="item-operate">
                            <router-link :to="'/branch/organ/serverEdit/'+item.id">
                                <i class="el-icon-edit"></i>
                            </router-link>
                            <i class="el-icon-delete margin-left" @click="deleteItem(item.id)"></i>
                        </div>
                    </div>
                </transition-group>
            </vuedraggable>
        </div>
    </div>
</template>

<script>
import {delServer, getServerList, sortServer} from '@/api/branch'
import vuedraggable from 'vuedraggable';

export default {
    name: "server",
    data() {
        return {
            lists: [],
            isSort: false,
            isDragging: false,
            delayedDragging: false,
            isDraggable: false,
            noData: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                ghostClass: "ghost"
            };
        }
    },
    created() {
        this.$emit('setIndex', [5, 3], '组织服务')
        this.init()
    },
    components: {vuedraggable},
    methods: {
        //  页面加载时请求
        async init() {
            let _data = await getServerList()
            if (_data.status === 200) {
                _data.data.map(item => {
                    item.label = item.label ? item.label.split(',') : []
                })
                this.lists = _data.data
                this.noData = _data.data.lists > 0
            } else {
                this.lists = []
                this.noData = true
            }
        },
        deleteItem(id) {
            this.$confirm("确定要删除此服务吗", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delServer(id)
            })
        },
        async delServer(id) {
            let _data = await delServer(id)
            if (_data.status === 200) {
                this.init()
                this.$message.success(_data.msg)
            }
        },
        sortList() {
            if (this.isSort) {
                this.sortServer()
            } else {
                this.isSort = true
            }
        },
        async sortServer() {
            let id = this.lists.map(item => {
                return item.id
            })
            let sort = this.lists.map((item, index) => {
                return index + 1
            })
            let _data = await sortServer(id, sort)
            if (_data.status === 200) {
                this.isSort = false
                this.$message.success(_data.msg)
            }
        },
        //  拖拽
        draggableEnd() {
            if (!this.isDraggable) {
                this.$notify({
                    title: '温馨提示',
                    message: '题目顺序调整完成后记得点击右上角的保存哦！ ^_^ ',
                    duration: 10000,
                    offset: 120
                });
            }
            this.isDraggable = true
        },
        //  拖拽结束
        onMove({relatedContext, draggedContext}) {
            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            );
        },
    },
    filters: {},
    watch: {
        isDragging(newValue) {
            if (newValue) {
                this.delayedDragging = true;
                return;
            }
            this.$nextTick(() => {
                this.delayedDragging = false;
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.warpper {
    .classifys {
        margin-top: 10px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            border-radius: 6px 0 0 6px;
            color: #ffb400;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 0 6px 6px 0;

            }
        }
    }

    .item {
        width: 100%;
        background-color: #f3f7fb;
        border-radius: 10px;
        margin-top: 20px;
        padding: 20px;

        .item-operate {
            display: none;
        }

        &.sort {
            &:hover {
                position: relative;
                cursor: pointer;

                .item-operate {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: #00000033;
                    border-radius: 10px;

                    i {
                        width: 80px;
                        height: 80px;
                        line-height: 80px;
                        border-radius: 80px;
                        text-align: center;
                        background: #ffffff;
                        color: #ed7d31;
                        font-size: 28px;
                        cursor: pointer;
                    }
                }
            }
        }

        .title {
            font-size: 20px;
            color: #333333;
            font-weight: bold;
            line-height: 22px;
        }

        .content {
            width: 100%;
            font-size: 14px;
            line-height: 26px;
            color: #666666;
            margin-top: 20px;

        }

        .line {
            border-bottom: 1px dotted #dae0e6;
            margin-top: 20px;
        }

        .count {
            min-width: 89px;
            height: 28px;
            line-height: 28px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 14px;
            color: #0a2240;
            text-align: center;
            padding: 0 12px;
            font-weight: bold;
            margin-top: 15px;
            margin-right: 20px;

            span {
                color: #ff9600;
            }
        }

        .tag {
            min-width: 82px;
            height: 28px;
            line-height: 28px;
            background-color: #ffffff;
            border-radius: 14px;
            border: solid 1px #dae0e6;
            font-size: 14px;
            color: #999999;
            text-align: center;
            margin-top: 15px;
            margin-right: 20px;
            padding: 0 12px;
        }

        .look {
            width: 99px;
            height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            border-radius: 10px;
            font-size: 16px;
            line-height: 40px;
            color: #ffffff;
            text-align: center;
            z-index: 3;

            span {
                font-size: 18px;
                font-weight: bold;
                margin-right: 6px;
            }
        }
    }
}
</style>